export const ANALYTICS_EVENT_IDPF = {
  DYNAMIC_VALUE: 'valor dinamico',
};
